// extracted by css-extract-rspack-plugin
export default {"modal":"modal-KM5nFO","header":"header-NnZ2nQ","content":"content-jmyNqf","form":"form-SStLgu","footer":"footer-WCxF9N"};